import React from "react";

import { LABELS } from "../../constants/assessment-content";

import styles from "./AssessmentExperienceLabel.module.scss";

type Props = {
  experienceNo?: number;
};

export const LABEL_COLORS: { [key: number]: string } = {
  1: "#6ab04c",
  2: "#eb4d4b",
  3: "#f9ca24",
  4: "#7ed6df",
  5: "#f0932b",
  6: "#95afc0",
  7: "#686de0",
};

const AssessmentExperienceLabel: React.FC<Props> = ({ experienceNo = 0 }) => {
  return (
    <span
      className={styles.label}
      style={{
        color: LABEL_COLORS[experienceNo],
        borderColor: LABEL_COLORS[experienceNo],
      }}
    >
      {LABELS[experienceNo]}
    </span>
  );
};

export default AssessmentExperienceLabel;
